<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/TuN4o0/tc-custom/9781451669060.jpg?1730490467322" alt="This image is the cover for the book Water Crystal Healing"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Water Crystal Healing
      </h1>
      <p class="bookDescription body article font2">
        <p>For centuries, people have turned to classical music for its calming and relaxing effects. Internationally acclaimed water researcher Dr. Masaru Emoto has discovered why certain music has healing benefits: Music with the appropriate rhythm, tempo, tone, and melody can correct distorted frequencies within our cells, assisting our health and healing.<br/><br/>Here, you can enjoy Dr. Emoto's captivating water-crystal photographs and text in this unique collection. The possible benefits you may experience include decreased joint and back pain; improved function of the nervous, circulatory, lymphatic, and immune systems; and the release of negative emotions such as anxiety, self-pity, and depression. The combination of images and words in <i>Water Crystal Healing</i> concentrates consciousness as never before, providing a unique experience for healing.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Masaru Emoto
      </h2>
      
      <p class="authorDescription body article"><B>Masaru Emoto</B> is an internationally renowned Japanese researcher who has gained worldwide acclaim. Emoto is a graduate of the Yokohama Municipal University's department of humanities and sciences with a focus on International Relations, and he receive certification as a Doctor of Alternative Medicine from the Open International University.<BR><BR>Emoto's research has visually captured the structure of water at the moment of freezing, and through high-speed photography he has shown the direct consequences of destructive thoughts and the thoughts of love and appreciation of the formation of water crystals. The revelation that our thoughts can influence water has profound implications for our health and the well-being of the planet.<BR><BR>Masaru Emoto has written many books, including the <I>New York Times</I> bestselling <I>The Hidden Messages in Water,</I> and his books have been published in twenty-four languages.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Atria
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0981dc6f